<template>
	<div class="brick" style="width:1250px;">
		<div class="list_top_box">
			<div class="left_option">
				<!-- <em class="lt_text">SO Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="so_date"/></span> -->
				<em class="lt_text">Sales Order No</em>
				<span class="int_type_no_border mgr_5">
					<SoSelect v-model.trim="so_dn" initialStatusCode="P" ref="so_dn" ph="Enter SO No or Scan Barcode" @set-invoice="getData()" @search="getData()" />
				</span>
				<a href="javascript:;" class="search_bt" @click="getData()">Search</a>
				<a href="javascript:;" class="gray_bt mgr_15" @click="reset()">Reset</a>
				<a href="javascript:;" class="gray_bt mgr_15" @click="excel()">Excel</a>
			</div>
		</div>
		<table class="list_tbl" id="scanned_so_items">
			<colgroup>
				<col style="width: 32%;" />
				<col style="width: 20%;" />
				<col style="width: 12%;" />
				<col style="width: 12%;" />
				<col style="width: 12%;" />
				<col style="width: 12%;" />
			</colgroup>
			<thead>
				<tr>
					<th>{{ headers.class }} Name</th>
					<th>Color Code</th>
					<th>Unit Price($)</th>
					<th>Order Quantity</th>
					<th>Scanned Quantity</th>
					<th>Scanned Amount($)</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(inv, index) in invoice_list" :key="index">
					<td>{{ inv.class_name }}</td>
					<td>{{ inv.color_code }}</td>
					<td class="al_right">{{ inv.unit_price || 0 | toCurrency }}</td>
					<td class="al_right">{{ inv.quantity || 0 | commaSeparated }}</td>
					<td class="al_right">{{ inv.boxed_quantity || 0 | commaSeparated }}</td>
					<td class="al_right">{{ ((inv.boxed_quantity || 0) * (inv.unit_price || 0)) | toCurrency }}</td>
				</tr>
				<tr v-if="invoice_list.length > 0">
					<td colspan="3" class="al_right"><b>Total</b></td>
					<td class="al_right">{{ invoice_list.reduce((acc, inv) => (acc += inv.quantity || 0), 0) | commaSeparated }}</td>
					<td class="al_right">{{ invoice_list.reduce((acc, inv) => (acc += inv.boxed_quantity || 0), 0) | commaSeparated }}</td>
					<td class="al_right">{{ invoice_list.reduce((acc, inv) => (acc += (inv.boxed_quantity || 0) * (inv.unit_price || 0)), 0) | toCurrency }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import SoSelect from '@/components/common/SoSelect';
import { apiScannedSOItems } from '@/api/report/report';
import { exportExcel } from '@/api/util';
export default {
	data: () => ({
		so_dn: null,
		search_so_dn: null,
		invoice_list: [],
	}),
	props: ['headers'],
	components: {
		SoSelect,
	},
	methods: {
		async getData() {
			this.search_so_dn = this.so_dn;
			let { data } = await apiScannedSOItems(this.search_so_dn);

			if (Array.isArray(data) && data.length > 0) this.invoice_list = data;
			else this.invoice_list = [];
		},
		reset() {
			this.so_dn = null;
		},
		excel() {
			if (!this.invoice_list.length) return this.$toast.error('No Data to Export');
			exportExcel('scanned_so_items', 'scanned_so_items_' + this.search_so_dn);
		},
	},
	created() {
		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_scanned_SO_items');
		this.$store.commit('setSubTitle', 'Report -> Scanned S/O Items');
	},
};
</script>

<style></style>
